import styled from '@emotion/styled';

export const TeamSettingsActivityPackageStyled = styled('div')`
	padding: 1rem 2rem;
`;
